import { getFontStyle } from '@diversioteam/diversio-ds'
import styled from 'styled-components'
import { colors } from '@diversioteam/diversio-ds'

import { ReactComponent as DiversioLogoSVG } from './../../../assets/images/diversio-logo-with-symbol-for-light-bg.svg'

export const ErrorContainer = styled.div`
    flex: 1;
    border-radius: 15px;
    height: 100%;
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
    align-items: center;
    background: ${({ theme }) => theme.colors.primaryWhite};
`

export const PreviewToastWrapper = styled.header`
    width: 100%;
    max-width: 800px;
    margin-bottom: 12px;

    .dds-toast {
        border-radius: 15px;
    }
`
export const HeaderToast = styled.header<{ isPreviewMode?: boolean }>`
    display: flex;
    margin-top: ${({ isPreviewMode }) => (isPreviewMode ? '0' : '48px')};
    justify-content: space-between;
    width: 100%;
    max-width: 800px;
    width: 100%;
    padding: 12px;
    margin-bottom: 48px;
    border-radius: 10px;
    background: ${({ theme }) => theme.colors.lobster00};
`
export const ErrorContentWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
`
export const IconContainer = styled.div``

export const ErrorMessage = styled.div`
    color: ${({ theme }) => theme.colors.primary90};
    ${getFontStyle('p02Medium')}
`

export const ButtonContainer = styled.div``

export const EmptyView = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    max-width: 868px;
    height: 100%;
    max-height: 850px;
`
export const StyledLogo = styled(DiversioLogoSVG)`
    width: 200px;
    height: auto;
    path,
    g {
        fill: ${colors.secondary100};
    }
`
